import { render, staticRenderFns } from "./questionsCastingCall.vue?vue&type=template&id=06d5596a&"
import script from "./questionsCastingCall.vue?vue&type=script&lang=js&"
export * from "./questionsCastingCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports